export default "__VITE_ASSET__53527c60__"